const helperGoogle = function (app) {

    const $document = $(document);
    const clickSelector = "[data-js-google-click]";

    const init = function () {

        // don't risk registering google events more than once a page
        if (!app.googleReady) {
            app.googleReady = true;
            registerEvents();
        }
    };

    const gtag = function (obj, callback) {
        if (!obj) {
            return;
        }

        const values = { ...obj.values };
        if (callback) {
            values['event_callback'] = callback;
        }

        if (window.gtag) {
            if (showDebug) {
                console.log("Google: gtag: " + JSON.stringify(obj))
            }
            window.gtag('event', obj.event, values);
        }
        else {
            if (showDebug) {
                console.log("Google: No gtag: " + JSON.stringify(obj))
            }
            if (callback) {
                callback();
            }
        }

    };

    const registerEvents = function () {

        $document.on('click', clickSelector, function (ev) {

            const $el = (ev ? $(this) : false);
            if (!$el) {
                return;
            }
            const googleEvent = $el.attr('data-js-google-event');
            if (googleEvent) {
                gtag(JSON.parse(googleEvent));
            }
        });

    };



    return {
        init: init(),
        gtag: gtag
    };

};

export default helperGoogle;